module.exports = __webpack_public_path__ + "img/高阶培训.5277ceff.png";